import axios from 'axios';
import { message } from 'starry-sky-ui';
import type { ApiResponse } from '@/types';

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === 'production'
      ? `${window.location.origin}/api`
      : 'http://localhost:3002/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {  
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    const { data } = response;
    if (data.success === false) {
      console.log(data,'response error');
      const { code, message: errMsg } = data;
      switch (code) {
        case 400:
          message.error(errMsg);
          break;
        case 401:
          
          localStorage.removeItem('token');
          window.location.href = '/admin/login';
          setTimeout(() => {
            message.error(errMsg);
          }, 1000);
          break;
        case 403:
          message.error(errMsg);
          break;
        case 404:
          message.error(errMsg);
          break;
        case 500:
          message.error('服务器内部错误');
          break;
        default:
          message.error(`请求错误: ${code}`);
      }
      return Promise.reject(data);
    }
    return data;
  },
);

/**
 * 类型安全的 request 工具
 * 拦截器已做 return data，所以直接返回 ApiResponse<T>
 */
const request = {
  get<T = unknown>(url: string, config?: Record<string, unknown>) {
    return instance.get(url, config) as unknown as Promise<ApiResponse<T>>;
  },
  post<T = unknown>(url: string, data?: unknown, config?: Record<string, unknown>) {
    return instance.post(url, data, config) as unknown as Promise<ApiResponse<T>>;
  },
  put<T = unknown>(url: string, data?: unknown, config?: Record<string, unknown>) {
    return instance.put(url, data, config) as unknown as Promise<ApiResponse<T>>;
  },
  delete<T = unknown>(url: string, config?: Record<string, unknown>) {
    return instance.delete(url, config) as unknown as Promise<ApiResponse<T>>;
  },
};

export default request;